<template>
  <div class="statethere disFlex flexdir justifycen alignCen">
    <div class="img"><img src="@/assets/images/chong.png" alt="" /></div>
    <div class="title">{{ $t("恭喜您密码重置成功快去登录吧") }}</div>
    <div>
      <el-button
        type="primary"
        @click="$router.push('/login')"
        class="regist co bco"
        >{{ $t("登陆") }}</el-button
      >
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.img {
  width: 80px;
  height: 80px;
  margin-top: 30px;
  margin-bottom: 25px;
  img {
    width: 80px;
    height: 80px;
  }
}
.title {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  margin-bottom: 120px;
}
.regist {
  width: 176px;
  height: 50px;
  background: #3b5ff0;
  border-radius: 4px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  border-color: transparent;
}
</style>
